// extracted by mini-css-extract-plugin
module.exports = {"termsAndConditionsWrapper":"eula_termsAndConditionsWrapper__JUUaM","header":"eula_header__yz8vM","customListContent":"eula_customListContent__7s9dm"};